/**
 * Minimal WebView bridge helpers for the Text2 mobile app shell.
 * No-op in normal browser; active when ReactNativeWebView is injected.
 */

const hasNativeBridge = () =>
  typeof window !== 'undefined' &&
  window.ReactNativeWebView &&
  typeof window.ReactNativeWebView.postMessage === 'function';

export const isText2MobileApp = () => hasNativeBridge();

export const requestNativePushPermission = () => {
  if (!hasNativeBridge()) return;
  window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'REQUEST_PUSH_PERMISSION' }));
};

export const getNativePushStatus = () => {
  if (!hasNativeBridge()) return;
  window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'GET_PUSH_STATUS' }));
};

export const registerNativePushFromSession = () => {
  if (!hasNativeBridge()) return false;
  const username = localStorage.getItem('username');
  const token = localStorage.getItem('token');
  if (!username || !token) return false;
  window.ReactNativeWebView.postMessage(
    JSON.stringify({ type: 'REGISTER_PUSH', username, token }),
  );
  return true;
};

export const subscribeNativePushEvents = (handler) => {
  if (typeof window === 'undefined') {
    return () => {};
  }
  const listener = (event) => {
    if (event && event.detail) {
      handler(event.detail);
    }
  };
  window.addEventListener('text2-native-push', listener);
  return () => window.removeEventListener('text2-native-push', listener);
};
